export enum ActionType {
    MOVE_CELL = 'MOVE_CELL',
    DELETE_CELL = 'DELETE_CELL',
    INSERT_CELL_AFTER = 'INSERT_CELL_AFTER',
    UPDATE_CELL = 'UPDATE_CELL',
    BUNDLE_START = 'BUNDLE_START',
    BUNDLE_COMPLETE = 'BUNDLE_COMPLETE',
    SAVE_START = 'START_START',
    SAVE_COMPLETE = 'START_COMPLETE', 
    SAVE_ERROR = 'START_ERROR',
    LOAD_START = 'LOAD_START',
    LOAD_COMPLETE = 'LOAD_COMPLETE', 
    LOAD_ERROR = 'LOAD_ERROR',
    LOGIN_USER_START = 'LOGIN_USER_START',
    LOGIN_USER_COMPLETE = 'LOGIN_USER_COMPLETE',
    LOGIN_USER_ERROR = 'LOGIN_USER_ERROR',
    LOGOUT_USER_START = 'LOGOUT_USER_START',
    LOGOUT_USER_COMPLETE = 'LOGOUT_USER_COMPLETE',
    LOGOUT_USER_ERROR = 'LOGOUT_USER_ERROR',
    CHECK_IF_LOGGED_IN = 'CHECK_IF_LOGGED_IN',
}